// Legacy fetch wrapper - used by GraphQL queries. API calls use Orval-generated client via src/api/custom-fetch.ts

import { handleLogout, msalInstance } from '@/utils/auth'

import { getKONGToken } from '@/utils/auth/tokenFetcher'
import { API_URL, USE_KONG_API } from '../env'

export const customFetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const account = msalInstance.getActiveAccount()

  if (!account) {
    throw new Error('No active account! Verify a user has been signed in and setActiveAccount has been called.')
  }

  const accessTokenRequest = {
    scopes: [],
    account: account
  }

  try {
    const response = await msalInstance.acquireTokenSilent(accessTokenRequest)
    const headers = new Headers(init?.headers)

    if (USE_KONG_API) {
      const token = await getKONGToken()

      headers.set('Authorization', `Bearer ${token}`)
    }

    console.log('JWT: \n', response.accessToken)
    headers.set('MsalAuthorization', `Bearer ${response.accessToken}`)

    // headers.set('Authorization', `Bearer ${token}`)
    headers.set('Content-Type', `application/json`)
    init = { ...init, headers }
  } catch (error) {
    console.error('Error acquiring token:', error)

    handleLogout()
  }

  return fetch(input, init)
    .then(response => {
      if (response.ok) {
        return response
      }
      throw response
    })
    .catch(async error => {
      if (error instanceof Response) {
        // Global handling for 401
        switch (error.status) {
          case 401:
            if (USE_KONG_API) {
              await getKONGToken()
            }

            try {
              window.location.href = `/401?cause=endpoint`
            } catch (error) {
              window.location.href = `/401`
            }
            break
          default:
            console.log('Some error occurred')
            break
        }
      } else {
        // Handle network errors
        console.log('Network error')
        console.error(error)
      }

      return error
    })
}
